import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { logout } from '@/lib/auth'
import { BottomNav } from './BottomNav'
import { Toaster } from '@/components/Toaster'
import { KemyoonLogo } from '@/components/KemyoonLogo'
import { Button } from '@/components/ui/button'
import { LogOut } from 'lucide-react'

export function ResidentLayout() {
  const { profile } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  // Hide chrome on individual conversation pages — they render their own
  // fixed full-screen layout with header, messages, and input.
  const isConversationPage =
    /^\/chat\/[^/]+$/.test(location.pathname) &&
    location.pathname !== '/chat/new'

  if (isConversationPage) {
    return (
      <>
        <Outlet />
        <Toaster />
      </>
    )
  }

  return (
    <div className="min-h-screen bg-muted/30">
      <header className="sticky top-0 z-40 border-b bg-background">
        <div className="mx-auto flex h-14 items-center justify-between px-4 lg:pl-60">
          <Link to="/" className="flex items-center">
            <KemyoonLogo size="sm" />
          </Link>
          <div className="flex items-center gap-2">
            {profile && (
              <span className="hidden text-sm text-muted-foreground sm:inline">
                {profile.first_name}
              </span>
            )}
            <Button variant="ghost" size="icon" onClick={handleLogout} aria-label="Sign out">
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>
      <BottomNav />
      <main className="mx-auto max-w-3xl px-4 py-6 pb-24 lg:ml-56 lg:pb-6">
        <Outlet />
      </main>
      <Toaster />
    </div>
  )
}
